import { Component, Prop, h, Event, EventEmitter, State } from '@stencil/core';
import { Questions, Answerobj, Data } from '../../model/index';
import { isnullorundefined } from '../../util/isnullorundefined';
import { isnotnullornotundefined } from '../../util/isnotnullorundefined';

@Component({
  tag: 'sg-answers',
  shadow: false
})
export class Answer {
  @Prop() disabled = false;
  @Prop() name?: string;
  @Prop() user?: string;
  @Prop() email?: string;
  @Prop() textsMap: Map<string, any>;

  @Prop() viewanswers: Answerobj;
  @Prop() response: Array<Questions> = [];
  @Prop() document?: string;
  @Prop() emailinput?: string;
  @Prop() isLoading = false;
  @State() invalid = true;
  @State() invalidDocument = true;
  @State() validemail = true;
  data: Data = { email: '', user: '', data: '1' };
  @State() validdocument = true;

  @Event({
    eventName: "resetQuestion",
    bubbles: false,
  }) resetQuestion: EventEmitter;

  preview: string;
  previewemail: string;
  @Event({
    eventName: "sendQuestion",
    bubbles: false,
  }) sendQuestion: EventEmitter<Data>;

  clickReset() {
    this.invalid = true;
    this.emailinput = undefined;
    this.document = undefined;
    this.resetQuestion.emit();
  }

  clickEmail(email) {
    this.emailinput = email;
    this.isValidEmail(this.emailinput);
  }

  clickSend = (ev: Event) => {
    this.data.email = this.emailinput;
    this.data.user = this.user ? this.user : this.document;

    ev.preventDefault();
    if (this.user) {
      if (this.viewanswers.emailflat && /^\w+([\.\+\-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(this.emailinput)) {
        this.disabled = true;
        this.sendQuestion.emit(this.data);
      } else {
        this.isValidEmail(this.emailinput);
      }
    } else {
      if (this.viewanswers.emailflat && this.viewanswers.numberidflat) {
        if (/^\w+([\.\+\-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(this.emailinput) && /^[0-9]+$/.test(this.document)) {
          console.log("validacion", /^[0-9]+$/.test(this.document));
          //console.log(this.document);
          this.disabled = true;
          this.isLoading = true;
          this.sendQuestion.emit(this.data);
        } else {
          this.isValidEmail(this.emailinput);
          this.isValidDocument(this.document);
        }
      }
      else if (this.viewanswers.emailflat && !this.viewanswers.numberidflat) {
        if (/^\w+([\.\+\-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(this.emailinput)) {
          this.disabled = true;
          this.isLoading = true;
          this.sendQuestion.emit(this.data);
        } else {
          this.isValidEmail(this.emailinput)
        }
      } else if (this.viewanswers.numberidflat && !this.viewanswers.emailflat) {
        if (/^[0-9]+$/.test(this.document)) {
          this.disabled = true;
          this.isLoading = true;
          this.sendQuestion.emit(this.data);
        } else {
          this.isValidDocument(this.document);
        }
      } else if (!this.viewanswers.emailflat && !this.viewanswers.numberidflat) {
        this.disabled = true;
        this.isLoading = true;
        this.sendQuestion.emit(this.data);
      } else {
        this.isValidEmail(this.emailinput)
      }
    }
  }

  isValidEmail(mail) {
    this.invalid = /^\w+([\.\+\-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(mail)
    return this.invalid;
  }

  isValidDocument(document) {
    this.invalidDocument = /^[0-9]+$/.test(document);
    console.log("validacion", this.invalidDocument)
    return this.invalidDocument;
  }

  render() {
    this.preview = !this.invalidDocument ? 'u-textShrink1 Input is-invalid' : 'u-textShrink1 Input';
    this.previewemail = !this.invalid ? 'u-textShrink1 Input is-invalid' : 'u-textShrink1 Input';
    if (this.viewanswers) {
      return (
        <div id="sgsummary" class="">
          <div class="u-contain u-padSides2 u-spaceBottom1">
            <header class="section-header">
              <h1 class="u-textSemibold u-textCenter">{this.textsMap.get(this.viewanswers.titleanswer)}</h1>
            </header>
            <div class="Grid Grid--withGap">
              <div class="Grid-cell">
                <ul class="no-bullets" id="summaryContainer">
                  {this.response.map((x) =>
                    x.answers.map((answer) =>
                      <li class="u-padEnds">
                        <span class="u-spaceLeft04" id={`question_${x.orderquestion}_answer_${answer.orderanswer}`}>{this.textsMap.get(answer.title)}</span>
                      </li>
                    ))}
                </ul>
              </div>
              <div class="Grid-cell">
                <div class="buttons-steps">
                  <button onClick={() => this.clickReset()} class="btn btn-repeat" >{this.textsMap.get(this.viewanswers.buttonrepeatanswer)}</button>
                </div>
              </div>
              <div class="Grid-cell">
                <div id="CT_Main_0_actiondefault" class="Grid Grid--alignCenter Grid--withGap u-padEnds">
                  <div class="Grid-cell Grid-cell u-size1of1 u-md-size2of3 u-textCenter">
                    <span class="u-padLeft02 hidden ">{this.textsMap.get(this.viewanswers.inputanswer)}
                      {
                        (isnotnullornotundefined(this.email)) && this.viewanswers.emailflat ?
                          <i> {this.textsMap.get(this.viewanswers.labelemailusage)} <a onClick={() => this.clickEmail(this.email)}
                            class="u-padBottom u-textShrink2"> ({this.email})</a> </i>
                          : <div></div>
                      }
                    </span>
                  </div>
                  {
                    this.viewanswers.emailflat ?
                      <div class="Grid-cell u-size1of1 u-md-size2of3">
                        <label id="labelemail" class="u-hidden">{this.textsMap.get(this.viewanswers.labelemail)}</label>
                        <input name="email" type="text" id="CT_Main_0_txtUsername" placeholder={this.textsMap.get(this.viewanswers.labelemail)+' *'}
                          class={this.previewemail}
                          onInput={(el) => this.emailinput = el.target["value"]} value={this.emailinput} autoComplete="off"
                          onChange={() => this.isValidEmail(this.emailinput)} maxlength="30" />
                        <span id="bartxtUsername" class="u-textShrink1 u-textRed" >{!this.invalid ? this.textsMap.get(this.viewanswers.messagerroranswer) : ''}</span>
                      </div>
                      : <div></div>
                  }
                  {
                    (isnullorundefined(this.user)) && this.viewanswers.numberidflat ?
                      <div class="Grid-cell u-size1of1 u-md-size2of3">
                        <label id="CT_Main_1_contactnonwysiwyg_labeltxtEmail" class="u-hidden">{this.textsMap.get(this.viewanswers.labelid)}</label>
                        <input name="CT_Main_1$contactnonwysiwyg$txtEmail"
                          type="tel" maxlength="15" id="CT_Main_1_contactnonwysiwyg_txtEmail" placeholder={this.textsMap.get(this.viewanswers.labelid)+' *'}
                          class={this.preview}
                          onInput={(el) => this.document = el.target["value"]} value={this.document} onChange={() => this.isValidDocument(this.document)} />
                        <span id="CT_Main_1_contactnonwysiwyg_bartxtEmail" class="u-block u-textShrink1 u-textRed">{!this.invalidDocument ? this.textsMap.get(this.viewanswers.messagerroranswer) : ''}</span>
                      </div>
                      : <div></div>
                  }

                  <p class="u-padTop u-textCenter">
                    {this.textsMap.get(this.viewanswers.descriptionanswer)}
                  </p>
                  <div class={this.isLoading ? 'Grid-cell u-size2of3 u-padBottom1 form-overlay is-loading Thumbnail' : 'Grid-cell u-size1of1 u-md-size2of3 u-padBottom1'}>
                    <input type="submit" name="CT_Main_0$btnSubmit2" value={this.textsMap.get(this.viewanswers.buttonsendanswer)} id="CT_Main_0_btnSubmit2"
                      class="btn Button ButtonRounded u-sizeFull" onClick={this.clickSend} disabled={this.disabled} />
                  </div>
                </div>
                <div class="u-padTop u-borderTopSm results-actions">
                  <span class="u-textBold">{this.textsMap.get(this.viewanswers.descriptionemail)}</span>
                  <p class="u-spaceEnds">
                    <label class="Toggle">
                      <input value="1" name="CT_Main_0$Newsletter" type="radio" id="CT_Main_0_rbtnNewsletterYes" checked class="Toggle-state"
                        onInput={(el) => this.data.data = el.target["value"]} />
                      <span class="Toggle-indicator" aria-hidden="true"></span>
                      <label > &nbsp;&nbsp;{this.textsMap.get(this.viewanswers.inputemail)}</label>
                    </label>
                  </p>
                  <p class="u-spaceEnds">
                    <label class="Toggle">
                      <input value="0" name="CT_Main_0$Newsletter" type="radio" id="CT_Main_0_rbtnNewsletterNo" class="Toggle-state"
                        onInput={(el) => this.data.data = el.target["value"]} />
                      <span class="Toggle-indicator" aria-hidden="true"></span>
                      <label > &nbsp;&nbsp;{this.textsMap.get(this.viewanswers.inputemailfalse)}</label>
                    </label>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return <div></div>
    }
  }
}
